import { MdKeyboardArrowDown } from "react-icons/md";
import styles from "./StoreFilterSelect.module.css";
import { cleanString } from "../../../../../../shared/cleanString";

export interface StoreFilterSelectOption {
  id: string;
  value: string;
  label: string;
}

interface StoreFilterSelectProps {
  title: string;
  valueLabel: string;
  selectAllLabel: string;
  options: StoreFilterSelectOption[];
  selectedValues: string[];
  allOptionsSelected: boolean;
  isOpen: boolean;
  onToggleOpen: () => void;
  onToggleAll: () => void;
  onToggleOption: (value: string) => void;
}

export function StoreFilterSelect({
  title,
  valueLabel,
  selectAllLabel,
  options,
  selectedValues,
  allOptionsSelected,
  isOpen,
  onToggleOpen,
  onToggleAll,
  onToggleOption,
}: StoreFilterSelectProps) {
  const sortedOptions = [...options].sort((a, b) =>
    cleanString(a.label).localeCompare(cleanString(b.label), undefined, {
      sensitivity: "base",
    }),
  );

  return (
    <div className={styles.container}>
      <span className={styles.title}>{title}</span>
      <button
        className={styles.selectButton}
        type="button"
        aria-expanded={isOpen}
        onClick={onToggleOpen}
      >
        <span
          className={`${styles.value} ${
            selectedValues.length ? styles.selected : ""
          }`}
        >
          {valueLabel}
        </span>
        <span className={`${styles.arrow} ${isOpen ? styles.open : ""}`}>
          <MdKeyboardArrowDown />
        </span>
      </button>

      {isOpen && (
        <div className={styles.optionsList}>
          <label className={styles.option}>
            <input
              className={styles.checkbox}
              type="checkbox"
              checked={allOptionsSelected}
              onChange={onToggleAll}
            />
            <span title={selectAllLabel}>{selectAllLabel}</span>
          </label>
          {sortedOptions.map((store) => (
            <label className={styles.option} key={store.id}>
              <input
                className={styles.checkbox}
                type="checkbox"
                checked={selectedValues.includes(store.value)}
                onChange={() => onToggleOption(store.value)}
              />
              <span title={store.label}>{store.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
